import { render, staticRenderFns } from "./TEFileUpload.vue?vue&type=template&id=52a11b8c"
import script from "./TEFileUpload.vue?vue&type=script&lang=js"
export * from "./TEFileUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports